<div class="layout-wrapper" [class]="containerClassString()">
  <app-topbar></app-topbar>
  <div class="layout-sidebar">
    <app-sidebar></app-sidebar>
  </div>
  <div class="layout-main-container">
    <div class="layout-main">
      <router-outlet></router-outlet>
    </div>
  </div>
  <div class="layout-mask"></div>
</div>

<app-theme-config />
<p-confirmDialog />
<p-toast />
